export default function formatCentsToUSDNoDecimals(
  cents: string | number | bigint | null | undefined
): string {
  try {
    const centsBig: bigint =
      typeof cents === "bigint"
        ? cents
        : typeof cents === "number"
          ? BigInt(Math.trunc(cents))
          : BigInt((cents ?? "0").toString().trim() || "0");

    const dollars = centsBig / 100n;

    const sign = dollars < 0n ? "-" : "";
    const abs = dollars < 0n ? -dollars : dollars;

    return `${sign}$${abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  } catch {
    return "$0";
  }
}
